/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Event_Duration_InvalidInputs */

const en_audio_recorder_event_duration_invalid = /** @type {(inputs: Audio_Recorder_Event_Duration_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event must be between 2 and 30 seconds to record audio.`)
};

const fr_audio_recorder_event_duration_invalid = /** @type {(inputs: Audio_Recorder_Event_Duration_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'événement doit durer entre 2 et 30 secondes pour enregistrer l'audio.`)
};

const de_audio_recorder_event_duration_invalid = /** @type {(inputs: Audio_Recorder_Event_Duration_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Ereignis muss zwischen 2 und 30 Sekunden dauern, um Audio aufzunehmen.`)
};

const it_audio_recorder_event_duration_invalid = /** @type {(inputs: Audio_Recorder_Event_Duration_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per registrare l'audio, l'evento deve durare tra 2 e 30 secondi.`)
};

const ru_audio_recorder_event_duration_invalid = /** @type {(inputs: Audio_Recorder_Event_Duration_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для записи звука длительность события должна составлять от 2 до 30 секунд.`)
};

const es_audio_recorder_event_duration_invalid = /** @type {(inputs: Audio_Recorder_Event_Duration_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El evento debe durar entre 2 y 30 segundos para grabar audio.`)
};

const zh_cn2_audio_recorder_event_duration_invalid = /** @type {(inputs: Audio_Recorder_Event_Duration_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件持续时间必须在 2 到 30 秒之间才能录制音频。`)
};

const ja_audio_recorder_event_duration_invalid = /** @type {(inputs: Audio_Recorder_Event_Duration_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオを録音するには、イベントの長さが 2 ～ 30 秒である必要があります。`)
};

const hi_audio_recorder_event_duration_invalid = /** @type {(inputs: Audio_Recorder_Event_Duration_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो रिकॉर्ड करने के लिए इवेंट की अवधि 2 से 30 सेकंड के बीच होनी चाहिए।`)
};

const pt_pt2_audio_recorder_event_duration_invalid = /** @type {(inputs: Audio_Recorder_Event_Duration_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O evento deve ter entre 2 e 30 segundos para que o áudio seja gravado.`)
};

/**
* | output |
* | --- |
* | "Event must be between 2 and 30 seconds to record audio." |
*
* @param {Audio_Recorder_Event_Duration_InvalidInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_event_duration_invalid = /** @type {((inputs?: Audio_Recorder_Event_Duration_InvalidInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Event_Duration_InvalidInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_event_duration_invalid(inputs)
	if (locale === "de") return de_audio_recorder_event_duration_invalid(inputs)
	if (locale === "it") return it_audio_recorder_event_duration_invalid(inputs)
	if (locale === "ru") return ru_audio_recorder_event_duration_invalid(inputs)
	if (locale === "es") return es_audio_recorder_event_duration_invalid(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_event_duration_invalid(inputs)
	if (locale === "ja") return ja_audio_recorder_event_duration_invalid(inputs)
	if (locale === "hi") return hi_audio_recorder_event_duration_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_event_duration_invalid(inputs)
	return en_audio_recorder_event_duration_invalid(inputs)
});